import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaArrowDown } from 'react-icons/fa';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { A_TOKENS, LENDING_POOL_ADDRESSES } from '../constants';
export var Withdraw = createPlugin({
    protocol: 'AAVE',
    type: 'ACTION',
    method: 'withdraw',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }), isPreview: true, icon: FaArrowDown }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    to: new FctAddress({}),
                },
            },
            output: {
                value: new FctValue({ innerIndex: 0 }),
            },
        });
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, _b = params.methodParams, amount = _b.amount, receiver = _b.to, asset = _b.asset;
        if (!asset.value || !to.value || !amount.value || !receiver.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' ||
            typeof receiver.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof to.value !== 'string')
            return [];
        var aToken = (_a = A_TOKENS[chainId]) === null || _a === void 0 ? void 0 : _a.find(function (token) { return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase(); });
        if (!aToken)
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: aToken.aTokenAddress,
                        amount: amount.value,
                    },
                ],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
